import { useLanguage } from "./LanguageContext";

export default function Hero() {
  const { t } = useLanguage();

  return (
    <section
      id="home"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        background: "linear-gradient(180deg, #1e3a5f 0%, #1e40af 40%, #3b82f6 70%, #bfdbfe 100%)",
        position: "relative",
        overflow: "hidden",
        padding: "80px 20px 60px",
      }}
    >
      {/* Decorative circles */}
      <div style={{
        position: "absolute",
        top: "-100px",
        right: "-100px",
        width: "400px",
        height: "400px",
        borderRadius: "50%",
        border: "1px solid rgba(255,255,255,0.1)",
      }} />
      <div style={{
        position: "absolute",
        bottom: "-150px",
        left: "-150px",
        width: "500px",
        height: "500px",
        borderRadius: "50%",
        border: "1px solid rgba(255,255,255,0.08)",
      }} />

      <div className="animate-fade-in-up" style={{ position: "relative", zIndex: 1 }}>
        <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: "1rem",
          letterSpacing: "4px",
          textTransform: "uppercase",
          color: "rgba(255,255,255,0.7)",
          marginBottom: "16px",
          fontWeight: 300,
        }}>
          {t.heroFamilies}
        </p>

        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "clamp(2.5rem, 8vw, 5rem)",
          color: "white",
          fontWeight: 400,
          lineHeight: 1.1,
          marginBottom: "8px",
        }}>
          Elijah
        </h1>

        <div className="divider-ornament" style={{ margin: "12px 0" }}>
          <span style={{
            color: "var(--gold-light)",
            fontFamily: "'Playfair Display', serif",
            fontStyle: "italic",
            fontSize: "1.2rem",
          }}>
            &amp;
          </span>
        </div>

        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "clamp(2.5rem, 8vw, 5rem)",
          color: "white",
          fontWeight: 400,
          lineHeight: 1.1,
          marginBottom: "24px",
        }}>
          Diana
        </h1>

        <div className="divider-ornament animate-delay-1" style={{ marginBottom: "24px" }}>
          <span style={{ color: "var(--gold-light)" }}></span>
        </div>

        <p className="animate-delay-2" style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: "clamp(1.1rem, 3vw, 1.5rem)",
          color: "rgba(255,255,255,0.9)",
          fontStyle: "italic",
          marginBottom: "12px",
        }}>
          {t.heroPleasure}
        </p>

        <p className="animate-delay-2" style={{
          fontSize: "1.1rem",
          color: "rgba(255,255,255,0.8)",
          letterSpacing: "2px",
          fontWeight: 300,
        }}>
          {t.heroDate}
        </p>

        <div className="animate-delay-3" style={{ marginTop: "40px" }}>
          <a
            href="#countdown"
            style={{
              display: "inline-block",
              padding: "12px 36px",
              border: "2px solid rgba(255,255,255,0.4)",
              borderRadius: "8px",
              color: "white",
              textDecoration: "none",
              fontSize: "0.9rem",
              letterSpacing: "2px",
              textTransform: "uppercase",
              transition: "all 0.3s",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "rgba(255,255,255,0.15)";
              e.target.style.borderColor = "rgba(255,255,255,0.6)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.borderColor = "rgba(255,255,255,0.4)";
            }}
          >
            {t.heroButton}
          </a>
        </div>
      </div>
    </section>
  );
}
